var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{class:['dml-label', ("dml-label--" + (_vm.props.type))]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }